import { ETAPAS_ESTEIRA, ETAPAS_MVP, ETAPAS_EM_BREVE } from './esteiraSidebar.constants';

export { ETAPAS_ESTEIRA, ETAPAS_MVP, ETAPAS_EM_BREVE };

export const deveExibirEtapasDaEsteira = contexto => Boolean(contexto?.codPpc);

export const podeNavegarParaEtapa = ({ etapa, temProposta, etapasDesabilitadas = [] }) => {
  if (!temProposta && etapa !== ETAPAS_ESTEIRA.HOME) {
    return false;
  }

  if (!ETAPAS_MVP.includes(etapa)) {
    return false;
  }

  if (etapasDesabilitadas.includes(etapa)) {
    return false;
  }

  return true;
};

export const isRotaEsteiraCredito = rota => typeof rota === 'string' && rota.includes('credito-esteira');

const normalizarTexto = valor =>
  (valor || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

const ORDEM_ETAPAS = {
  [ETAPAS_ESTEIRA.HOME]: 0,
  [ETAPAS_ESTEIRA.AUDITORIA_DOCUMENTAL]: 1,
  [ETAPAS_ESTEIRA.PERFORMANCE_DOCUMENTAL]: 2
};

const STATUS_PARA_ORDEM_FLUXO = {
  'pendente de auditoria': ORDEM_ETAPAS[ETAPAS_ESTEIRA.AUDITORIA_DOCUMENTAL],
  'em auditoria': ORDEM_ETAPAS[ETAPAS_ESTEIRA.AUDITORIA_DOCUMENTAL],
  performance: ORDEM_ETAPAS[ETAPAS_ESTEIRA.PERFORMANCE_DOCUMENTAL],
  'em performance': ORDEM_ETAPAS[ETAPAS_ESTEIRA.PERFORMANCE_DOCUMENTAL],
  'pendente de analise': ORDEM_ETAPAS[ETAPAS_ESTEIRA.PERFORMANCE_DOCUMENTAL] + 1,
  'em analise': ORDEM_ETAPAS[ETAPAS_ESTEIRA.PERFORMANCE_DOCUMENTAL] + 1,
  'aguardando comite': ORDEM_ETAPAS[ETAPAS_ESTEIRA.PERFORMANCE_DOCUMENTAL] + 1
};

const resolverEtapaDoSubMenu = subMenu => {
  const rota = normalizarTexto(subMenu?.rota);
  const texto = normalizarTexto(subMenu?.texto);

  if (rota.includes('proposta') || rota.includes('mesa') || texto.includes('propostas')) {
    return ETAPAS_ESTEIRA.HOME;
  }

  if (rota.includes('auditoria') || texto.includes('auditoria')) {
    return ETAPAS_ESTEIRA.AUDITORIA_DOCUMENTAL;
  }

  if (rota.includes('performance') || texto.includes('performance')) {
    return ETAPAS_ESTEIRA.PERFORMANCE_DOCUMENTAL;
  }

  if (rota.includes('analise-cadastral') || texto.includes('analise cadastral')) {
    return ETAPAS_ESTEIRA.ANALISE_CADASTRAL;
  }

  if (rota.includes('socios') || texto.includes('socios e vinculos')) {
    return ETAPAS_ESTEIRA.SOCIOS_VINCULOS;
  }

  if (
    rota.includes('analise-financeira') ||
    texto.includes('analise financeira') ||
    texto.includes('financeiro')
  ) {
    return ETAPAS_ESTEIRA.ANALISE_FINANCEIRA;
  }

  if (texto.includes('apontamento')) {
    return ETAPAS_ESTEIRA.PARECER_FINAL;
  }

  if (rota.includes('parecer') || texto.includes('parecer final')) {
    return ETAPAS_ESTEIRA.PARECER_FINAL;
  }

  return null;
};

const resolverOrdemStatusProposta = statusProposta => {
  const statusNormalizado = normalizarTexto(statusProposta);

  if (statusNormalizado in STATUS_PARA_ORDEM_FLUXO) {
    return STATUS_PARA_ORDEM_FLUXO[statusNormalizado];
  }

  return null;
};

const etapaEstaConcluida = ({ etapa, etapaAtual, statusProposta, possuiProposta }) => {
  if (!possuiProposta) {
    return false;
  }

  if (etapa === ETAPAS_ESTEIRA.HOME) {
    return false;
  }

  const ordemEtapa = ORDEM_ETAPAS[etapa];
  const ordemStatus = resolverOrdemStatusProposta(statusProposta);
  const ordemEtapaAtual = ORDEM_ETAPAS[etapaAtual];

  if (typeof ordemEtapa !== 'number') {
    return false;
  }

  if (typeof ordemStatus === 'number') {
    return ordemStatus > ordemEtapa;
  }

  if (typeof ordemEtapaAtual === 'number') {
    return ordemEtapaAtual > ordemEtapa;
  }

  return false;
};

export const montarItensEsteira = ({ contextoEsteira, rotaAtual, subMenus = [] }) => {
  const esteiraAtiva = isRotaEsteiraCredito(rotaAtual) || deveExibirEtapasDaEsteira(contextoEsteira);

  if (!esteiraAtiva) {
    return [];
  }

  const etapaAtual = contextoEsteira?.etapaAtual ?? ETAPAS_ESTEIRA.HOME;
  const statusProposta = contextoEsteira?.statusProposta ?? null;
  const possuiProposta = Boolean(contextoEsteira?.codPpc);

  if (!possuiProposta) {
    return [];
  }

  return subMenus.map(subMenu => {
    const etapa = resolverEtapaDoSubMenu(subMenu);

    if (!etapa) {
      return {
        ...subMenu,
        etapa: null,
        ativa: false,
        validada: false,
        emBreve: false,
        desabilitada: true
      };
    }

    return {
      ...subMenu,
      etapa,
      ativa: etapaAtual === etapa,
      validada: etapaEstaConcluida({
        etapa,
        etapaAtual,
        statusProposta,
        possuiProposta
      }),
      emBreve: ETAPAS_EM_BREVE.includes(etapa),
      desabilitada:
        ETAPAS_EM_BREVE.includes(etapa) ||
        !podeNavegarParaEtapa({
          etapa,
          temProposta: possuiProposta,
          etapasDesabilitadas: contextoEsteira?.etapasBloqueadas ?? []
        })
    };
  });
};
